import { seoGuidePages } from '../data/seoPages';
import { trackEvent } from '../lib/analytics';

const hubGroups = [
  {
    title: 'Kopen en beginnen',
    copy: 'Voor bezoekers die zoeken op kopen, starterset of eerste materiaal.',
    clusters: ['koopintentie', 'startersets', 'paddles']
  },
  {
    title: 'Ballen, netten en veld',
    copy: 'Voor indoor/outdoor vragen, sporthal, buitenbaan en tijdelijk veld.',
    clusters: ['ballen', 'netten-en-belijning', 'regels-en-veld']
  },
  {
    title: 'Clubs, scholen en clinics',
    copy: 'Voor groepsaankopen, bewegingsonderwijs en offerte-intentie.',
    clusters: ['b2b-club-school']
  },
  {
    title: 'Nederland, Belgie en lokaal',
    copy: 'Voor regionale zoekintentie en entity-signalen zonder winkelclaim.',
    clusters: ['geo-nederland', 'geo-belgie', 'geo-lokaal']
  }
];

export function SeoHubSection() {
  return (
    <section className="section seoHub" id="gidsen">
      <p className="eyebrow">Keuzehulp-hubs</p>
      <h2>Vindbare gidsen voor elke koopvraag.</h2>
      <p className="sectionIntro">
        Lees praktische gidsen voor startersets, paddles, ballen, netten, spelen in Nederland en Belgie, en pakketten voor clubs of scholen.
      </p>
      <div className="seoHubClusterGrid">
        {hubGroups.map((group) => {
          const pages = seoGuidePages.filter((page) => group.clusters.includes(page.cluster)).slice(0, 6);
          return (
            <article className="seoHubCluster" key={group.title}>
              <h3>{group.title}</h3>
              <p>{group.copy}</p>
              <div>
                {pages.map((page) => (
                  <a key={page.slug} href={page.slug} onClick={() => trackEvent({ event: 'category_click', location: 'homepage-seo-hub', label: page.keyword, routeFamily: 'seo_hub', placement: group.title })}>
                    <strong>{page.title}</strong>
                    <span>{page.keyword} - {page.buyerStage}</span>
                  </a>
                ))}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
